import { render } from "./DateCompanie.vue?vue&type=template&id=583b8aae&scoped=true&ts=true"
import script from "./DateCompanie.ts?vue&type=script&lang=ts"
export * from "./DateCompanie.ts?vue&type=script&lang=ts"

import "./DateCompanie.vue?vue&type=style&index=0&id=583b8aae&scoped=true&lang=scss"

import exportComponent from "D:\\ColorMetalRO\\cmportal-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-583b8aae"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
